export default function runner(
	state = { runner: null, friend: null, count: null},
	action
) {
switch(action.type) {

case "dispatchRunner" : {
return Object.assign({}, state, { runner: action.clickedRunner, friend: null });
}

case "dispatchFriend" : {
return Object.assign({}, state, { runner: action.clickedRunner, friend: true });
}

case "dispatchRequest" : {
return Object.assign({}, state, { runner: action.clickedRunner, friend: "request" });
}

case "dispatchCount" : {
return Object.assign({}, state, { count: action.count });
}

default : return state

}
}
